export default __webpack_public_path__ + "static/media/materializecss.10537047.svg";